<template>
  <div class="mobile_listen">
    <p
      style="
        text-align: center;
        color: #fff;
        font-size: 26px;
        font-weight: 700;
        margin-bottom: 15px;
      " 
    class="mobile_listen_p">
      听听他们怎么说？
    </p>
    <div id="Swip" ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in listenList"
          :key="index"
          class="swiper-slide"
        >
          <div class="swiper_slide_content">
            <p class="double_quotation_marks">"</p>
            <p class="swiper_slide_title">{{ item.msg }}</p>
            <p class="swiper_slide_author">{{ item.author }}</p>
          </div>
        </div>
      </div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data() {
    return {

    };
  },
  props: {
    listenList: {
      type: Array,
      default: () => []
    }
  },

  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 5000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: true,
    });
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .swiper_slide_title{
    font-size: 20px !important;
  }
  .swiper_slide_author {
    font-size: 18px !important;
  }
  .mobile_listen_p{
    font-size: 45px !important;
  }
}
.swiper_slide_content{
  width: 86% !important;
}
@import "@/styles/en_mobile/mobile_xty.scss";
</style>